import { render, staticRenderFns } from "./Small.vue?vue&type=template&id=3fc46988&scoped=true"
import script from "./Small.vue?vue&type=script&lang=js"
export * from "./Small.vue?vue&type=script&lang=js"
import style0 from "./Small.vue?vue&type=style&index=0&id=3fc46988&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc46988",
  null
  
)

export default component.exports